module.exports = __webpack_public_path__ + "img/6e53785.jpg";